module.exports = __webpack_public_path__ + "assets/img/process-1.b7ba29d1.png";